// extracted by mini-css-extract-plugin
export var button = "_y-0";
export var buttonContent = "_y-e";
export var buttonGroup = "_y-c";
export var dontRestrainIconWidth = "_y-a";
export var dropdownButton = "_y-b";
export var iconContainer = "_y-9";
export var lg = "_y-4";
export var md = "_y-3";
export var pending = "_y-f";
export var sm = "_y-2";
export var spinner = "_y-d";
export var squared = "_y-8";
export var wrapText = "_y-g";
export var xl = "_y-5";
export var xs = "_y-1";
export var xxl = "_y-6";
export var xxxl = "_y-7";